var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLoopTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8 35c0 1.8 1.2 3.2 2.7 3.2s2.7-1.5 2.7-3.2H85v10H43.1c0-1.8-1.2-3.2-2.7-3.2s-2.7 1.5-2.7 3.2H11V35h26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3 38.7h-6.6c-.3-.6-.9-.9-1.5-.9-1 0-1.9 1-1.9 2.3 0 1.2.8 2.3 1.9 2.3.6 0 1.2-.4 1.5-.9h6.6c.5 0 1-.5 1-1.2V40c0-.8-.4-1.3-1-1.3z"
  }))));
};
export default SvgLoopTag;